/**
 * Measure shard (issue #696). One entry per declared number.
 *
 * First entry is the Phase-2 mechanism proof: one existing measure bound
 * end-to-end so the compiler gate is demonstrated before the sweep depends
 * on it. Its semantics are unchanged from the live system — the population
 * predicate is the hoisted isFirmDecision, byte-for-byte the logic the
 * snapshot and atom extractor already shared.
 */
import { isFirmDecision } from "./predicates";
import type { MeasureEntry } from "./types";

export const MEASURES = [
  {
    id: "placement.time_to_decision",
    what: "Average calendar days from Date Sent to Date Responded over the window's firm decisions; pairs with a missing or inverted stamp are excluded, never clamped.",
    population: isFirmDecision,
    additivity: "non-additive",
    window: "friday-week",
    enforcement: "tsc",
    // The two registry card-id aliases (card.fs.hf_time_to_decision,
    // operations.avg_time_to_decision_days) were DROPPED by the #740 wipe —
    // they named surfaces the ruled wipe deleted (catalog entry
    // ttd_measure_aliases_name_wiped_cards). TTD and the phrase alias stay.
    aliases: [
      "TTD",
      "time to decision",
    ],
    not: [
      "Time-to-acceptance (card.fs.hf_tta, parked) — a different clock with a different endpoint.",
      "Acknowledgement time — operations/TABLES.md documents Date Responded as the acknowledgement stamp; this measure reads it as the decision moment (inventory COLLISIONS.decision).",
      "A stored ratio — the compute returns { daysSum, count } and the average is taken at read time; the parts are additive, the quotient is not.",
    ],
    ratified: {
      on: "2026-08-05",
      rejected: [
        "Whitelisting until a full pass runs — rejected; the entry is the Phase-2 mechanism proof and its semantics were already ruled.",
      ],
      rationale:
        "Chris, approved as declared after full walk-through: the live TTD semantics (firm decisions only, Friday week, parts stored / average at read, defective pairs excluded) carried into the canon unchanged.",
    },
  },
] as const satisfies readonly MeasureEntry[];
